import { BookingServices } from '../../types';
import { ModelAdapters } from '../model-adapters';

/**
 * Basisklasse aller Buchungs-Adapter: kapselt den gemeinsamen Zugriff auf die
 * App-Services und die übrigen Modell-Adapter.
 */
export abstract class Adapter {
  constructor(
    protected readonly services: BookingServices,
    protected readonly adapters: ModelAdapters,
  ) {}
}
